import React, { memo } from 'react';

import * as Types from './types';

import style from './GameLivePlayersNumber.scss';

export const GameLivePlayersNumberBare: React.FC<Types.IGameLivePlayersNumberProps> = ({ game, className = '' }) => {
    const { liveConfiguration } = game;

    if (!liveConfiguration?.seatsInfo) {
        return null;
    }

    return <span className={`${style.playersNumber} ${className} cms-games-grid-live-players-number`}>{liveConfiguration.seatsInfo}</span>;
};

export const GameLivePlayersNumber = memo(GameLivePlayersNumberBare);
